/*! @license
 * MedienMacher BWG
 *
 * copyright 2020 MedienMacher BWG (https://medienmacher-bwg.de/)
*/

// add js class to html element if js is supported
document.documentElement.classList.add('js');
if (process.env.NODE_ENV !== 'production') console.log('We\'re in dev mode!');

import barba from '@barba/core';
import 'lazysizes';
import Splitting from "splitting";
import ScrollMagic from 'ScrollMagic';
import { gsap, TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

import { select, selectAll, ready, scrollTo } from './../../_global/js/utility/utils';
import { initNav, closeMenu, removeNavActiveClass, addNavActiveClass } from './components/nav';
// import { initWordSplitting } from './components/wordSplitting';
// import { enableLogo, disableLogo, resetLogo, initLogo } from './components/logo';
import initComposition from './scrollMagic/composition';

import { initSlideInElements, observeElements, unobserveElements } from './../../_global/js/utility/slideInElements';

import { initModals } from './../../_global/js/components/modal';

Splitting();

initNav(true);
window.addEventListener('resize', initNav);

// initWordSplitting();

// initLogo();



const finishedScrolling = new Event('finishedScrolling');



/********************
 * current
 ********************/
barba.hooks.before(() => {
  barba.wrapper.classList.add('is-animating');
});



barba.hooks.beforeLeave(({next}) => {
  // scroll to the top
  let scrollPos = 0;
  if (next.url.hash != undefined) {
    const target = select(`#${next.url.hash}`);
    const targetOffset = target ? target.getBoundingClientRect().top : 0;
    scrollPos = targetOffset + window.pageYOffset;
  }
  // window.scrollTo(0, scrollPos);
  scrollTo(scrollPos, () => {
    document.dispatchEvent(finishedScrolling);
  });
});



barba.hooks.leave(({ current }) => {
  removeNavActiveClass(current);
});



barba.hooks.afterLeave(({ current, next }) => {
  // remove old namespace from body classList
  document.body.classList.remove(current.namespace);

  // replace old body classes with the new ones
  let regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi,
      match = regexp.exec(next.html);
  if (!match || !match[1]) return;
  document.body.setAttribute('class', match[1]);
});



/********************
 * next
 ********************/
barba.hooks.beforeEnter(({ current, next }) => {
 // add new namespace to body classList
 document.body.classList.add(next.namespace);

 // evaluate email obfuscator scripts
 const scripts = selectAll('script', next.container);
 scripts.forEach(script => {
   if (script.id === '') return;
   if (script.id.startsWith('script_enkoder_')) eval(script.innerHTML);
 });

 // // scroll to the top
 // let scrollPos = 0;
 // if (next.url.hash != undefined) {
 //   const target = select(`#${next.url.hash}`);
 //   const targetOffset = target ? target.getBoundingClientRect().top : 0;
 //   scrollPos = targetOffset + window.pageYOffset;
 // }
 // // window.scrollTo(0, scrollPos);
 // scrollTo(scrollPos, () => {
 //   document.dispatchEvent(finishedScrolling);
 // });
});



barba.hooks.enter(({ next }) => {
  addNavActiveClass(next);
});



barba.hooks.afterEnter(() => {
});



barba.hooks.after(() => {
  barba.wrapper.classList.remove('is-animating');
});



const pageTransitionEnd = new Event('pageTransitionEnd');
let duration = .8,
    ease = 'power4.inOut';



/* import barba views */
import Home from './pages/home';
import Team from './pages/team';
import Job from './pages/job';
import Contact from './pages/contact';
import Project from './pages/project';



/* transitions */
import once from './transitions/once';



const transitionOverlay = document.querySelector('.transition-overlay');
const transitionOverlayBg = document.querySelector('.transition-overlay-bg');



barba.init({
  debug: true,
  prevent: ({ el }) => el.classList && el.classList.contains('prevent'),

  views: [Home, Team, Job, Contact, Project],

  transitions: [{
    name: 'default-fade',



    once: ({ next }) => {
      once(next.container);

      initComposition();

      initSlideInElements();
      observeElements();
      initModals(true);

      // initial overlay animation
      document.dispatchEvent(pageTransitionEnd);
      document.dispatchEvent(finishedScrolling);
    },



    // leave(data) {
    //   closeMenu();
    //
    //   // leave animation
    //   return gsap.to(data.current.container, {
    //     autoAlpha: 0,
    //     duration: duration,
    //   });
    // },
    //
    //
    //
    // enter(data) {
    //   // enter animation
    //   return gsap.from(data.next.container, {
    //     autoAlpha: 0,
    //     duration: duration,
    //     onComplete: () => {
    //       document.dispatchEvent(pageTransitionEnd);
    //     }
    //   });
    // },



    leave: ({ current }) => {
      closeMenu();

      unobserveElements();

      // return gsap.to(current.container, {
      //   autoAlpha: 0,
      //   y: 200,
      //   duration: duration,
      // });

      const tl = gsap.timeline();

      tl.to(transitionOverlayBg, {
        y: 0,
        duration: duration,
        ease: ease
      });

      return tl.to(transitionOverlay, {
        y: 0,
        duration: duration,
        ease: ease
      }, `-=${duration - .2}`);
    },



    beforeEnter: ({ next }) => {
      next.container.style.zIndex = -1;

      // disableLogo();
      // initScrollMagic(data.next.container);
      initComposition(next.container);
    },



    enter: ({ next }) => {
      observeElements();

      const endTransition = () => {
        document.removeEventListener('finishedScrolling', endTransition);
        // gsap.from(next.container, {
        //   autoAlpha: 0,
        //   y: 200,
        //   duration: duration,
        //   onComplete: () => {
        //     document.dispatchEvent(pageTransitionEnd);
        //   }
        // });

        const tl = gsap.timeline();

        tl.to(transitionOverlay, {
          y: '100%',
          duration: duration,
          ease: ease
        });

        tl.to(transitionOverlayBg, {
          y: '100%',
          duration: duration,
          ease: ease,
          onComplete: () => {
            document.dispatchEvent(pageTransitionEnd);
            gsap.set(transitionOverlay, {y: '-100%'});
            gsap.set(transitionOverlayBg, {y: '-100%'});
          }
        }, `-=${duration - .2}`);
      }

      return (window.pageYOffset === 0) ? endTransition() : document.addEventListener('finishedScrolling', endTransition);
    },



  }],
});
